import React, { Component } from "react";
// import ContrastDarkMode from "../../static/images/sponsors/contrast-dark-logo.png";
// import ContrastLightMode from "../../static/images/sponsors/contrast-light-logo.png";
import ECS from "../../static/images/sponsors/ECS.png";
// import NoStarchPress from "../../static/images/sponsors/no-starch-logo.png";
// import ToooLDarkMode from "../../static/images/sponsors/toool-light-logo.png";
// import TooolLightMode from "../../static/images/sponsors/toool-dark-logo.png";
// import Fnbo from "../../static/images/sponsors/fnbo.png";
// import CheckPoint from "../../static/images/sponsors/checkpoint-dark-logo.png";
// import AppGateDark from "../../static/images/sponsors/appgate-dark-logo.png";
// import AppGateLight from "../../static/images/sponsors/appgate-light-logo.png";
// import RedCanary from "../../static/images/sponsors/red_canary.png";
import AWSDark from "../../static/images/sponsors/AWS_black.png";
import AWSLight from "../../static/images/sponsors/AWS-color.png";
// import Netsecuris from '../../static/images/sponsors/Netsecuris.jpg';
import ConAgraLight from "../../static/images/sponsors/conagra-light-logo.webp";
import ConAgraDark from "../../static/images/sponsors/conagra-logo-mobile.png";
// import Protiviti from "../../static/images/sponsors/protiviti.png";
import ZscalerLight from "../../static/images/sponsors/zscaler.png";
import ZscalerDark from "../../static/images/sponsors/Zscaler_BrandAssets_LogoLockup_White.png";
// import BairdHolm from "../../static/images/sponsors/bairdholm.png";
import GuidepointDark from "../../static/images/sponsors/guidepoint_black.png";
import GuidepointLight from "../../static/images/sponsors/guidepoint_black.png";
import KernelConCombinedLogos4 from "../../static/images/sponsors/KernelCon Combined Logos_4.png";
// import Tanium from "../../static/images/sponsors/Tanium.png";
// import Axonius from "../../static/images/sponsors/Axonius.png";
// import Wiz from "../../static/images/sponsors/wiz.png";
// import Code42 from "../../static/images/sponsors/code42.png";
import FarmCreditDark from "../../static/images/sponsors/farm-credit-dark-mode.png";
import FarmCreditLight from "../../static/images/sponsors/farm-credit-light-mode.png";
import HalcyonDark from "../../static/images/sponsors/Halcyon_dark_mode.png";
import HalcyonLight from "../../static/images/sponsors/Halcyon_light_mode.png";
// import MentalHealthHackersDark from "../../static/images/logos/MHH-white.png"
// import MentalHealthHackersLight from "../../static/images/logos/MHH.png"
// import SecureSkyDark from "../../static/images/sponsors/securesky-dark.png"
// import SecureSkyLight from "../../static/images/sponsors/securesky-light.png"
// import TrailOfBitsDark from "../../static/images/sponsors/trailofbits-dark-mode.png"
// import TrailOfBitsLight from "../../static/images/sponsors/trailofbits-light-mode.png"
// import EvolvingSolDark from "../../static/images/sponsors/evolving-sol-dark-mode.png"
// import EvolvingSolLight from "../../static/images/sponsors/evolving-sol-light-mode.png";
// import Falkor from "../../static/images/sponsors/FS_Purple.png";
// import TekSystems from "../../static/images/logos/teksystems.png"
// import ExpelDark from "../../static/images/sponsors/expel-dark-mode.png"
// import ExpelLight from "../../static/images/sponsors/expel-light-mode.png"
// import AmazonDark from "../../static/images/sponsors/amazon-dark-mode.png"
// import AmazonLight from "../../static/images/sponsors/amazon-light-mode.png"
import Turngate from "../../static/images/sponsors/turn-gate.png"
// import Phosphorus from "../../static/images/sponsors/phosphorus.png"
// import RecordedFuture from "../../static/images/sponsors/recorded-future.png"
// import Runza from "../../static/images/sponsors/runza-logo-tagline.png"
// import CyberCityCircuits from "../../static/images/logos/cyber_city_circuits_logo.png"
import EthicalIntruder from '../../static/images/sponsors/ethical_intruder_logo.jpg'
import ExtraHop from '../../static/images/sponsors/ExtraHop2024-Logo_color_medium.png'
// import CSO from '../../static/images/sponsors/cso.png'
import Shamar from '../../static/images/sponsors/shamar.png'
// import SentOneWhite from '../../static/images/sponsors/sentone_white.png'
// import SHIWhite from '../../static/images/sponsors/shi_white.png'
// import SHIDark from '../../static/images/sponsors/shi_dark.png'
// import Cyera_Light from '../../static/images/sponsors/Cyera_Logo_Inverted.png'
// import Cyera_Dark from '../../static/images/sponsors/Cyera_Logo_Primary.png'
// import CyberArk_Light from '../../static/images/sponsors/cyberark-light.png'
// import CyberArk_Dark from '../../static/images/sponsors/cyberark-dark.png' 
// import ZScalar_Light from '../../static/images/sponsors/zscalar-light.png'
// import ZScalar_Dark from '../../static/images/sponsors/zscalar-dark.svg'
import Trace3Dark from '../../static/images/sponsors/Trace3_Logo_WhiteBlue.png'
import Trace3Light from '../../static/images/sponsors/Trace3_Logo.png'
import CriblDark from '../../static/images/sponsors/cribl-dark-mode.svg'
import CriblLight from '../../static/images/sponsors/cribl-light-mode.svg'
import MoODark from '../../static/images/sponsors/MoO_dark_mode.png'
import MoOLight from '../../static/images/sponsors/MoO_light_mode.png'
import ZafranRegular from '../../static/images/sponsors/Zafran Logo - Regular.png'
import ZafranWhite from '../../static/images/sponsors/Zafran Logo - White.png'
import PromptS1Regular from '../../static/images/sponsors/Prompt-S1-Lockup-Regular.png'
import PromptS1White from '../../static/images/sponsors/Prompt-S1-Lockup-White.svg'
import Rapid7Dark from '../../static/images/sponsors/rapid_7_dark_mode.png'
import Rapid7Light from '../../static/images/sponsors/rapid_7_light_mode.png'
import SurfAIDark from '../../static/images/logos/SurfAI Type Dark Cherry.png'
import SurfAIWhite from '../../static/images/logos/SurfAI Type White.png'
import CrowdStrikeLight from '../../static/images/logos/CrowdStrike_light_mode.png'
import CrowdStrikeDark from '../../static/images/logos/CrowdStrike_Logo_dark_mode.png'
import ThreatLockerColor from '../../static/images/logos/ThreatLocker_logo wordmark_color_PNG 1200.png'
import ThreatLockerWhite from '../../static/images/logos/ThreatLocker_logo wordmark_white_PNG 1200.png'
import OptivLogo from '../../static/images/logos/OPTIV_rgb.svg'
import RubrikLogo from '../../static/images/logos/Rubrik-Logo-1C-Brandmark-Linear-100 (1).webp'
import FireCompassLight from '../../static/images/logos/Firecompass logo Transparant.png'

import "./Sponsors.scss";

export default class Sponsors extends Component {
	static displayName = "Sponsors";

	render() {
		return (
      <div className="container">
        <div className='venue-section'>
          <div className="sponsors">
            <div>
              <h3>Sponsorship</h3>
              <div className="text-block">
                <p>
                  We understand your products and services play an
                  important part in our security and we can’t put on
                  this conference without your help. The Omaha
                  metropolitan area is home to 45,000 businesses,
                  including Fortune 500 companies, large financial
                  companies, global technology service providers, the
                  University of Nebraska system, and important U.S.
                  Armed forces operations. If you’re not already doing
                  business in Omaha, you should be.
                </p>
                <p>
                  Get your name and product in front of hundreds of
                  security professionals and key decision makers with
                  a Kernelcon sponsorship. We will be happy to work
                  with you on details of your sponsorship, options
                  available and sponsorship fees.
                </p>
                <p>
                  While we do appreciate our sponsors, please
                  understand that Kernelcon is first and foremost for
                  our attendees so we can only accept sponsors who
                  have their best interests in mind.
                </p>
                <div className="tab-title">
                  Sponsorships are now available. Please contact{" "}
                  <a
                    href="mailto:sponsor@kernelcon.org?Subject=Sponorship"
                    style={{ textDecoration: "underline" }}
                    target="_top">
                    sponsor@kernelcon.org
                  </a>
                  .
                </div>
              </div>
            </div>
            <div>
              <h3 className="title">Sponsor a Student</h3>
              <div className="text-block">
                <h4>
                  Interested in sponsoring a student for this year's
                  Kernelcon?
                </h4>
                <p>
                  With your assistance, Kernelcon hopes to sponsor up
                  to 50 students this year. In addition to entry for
                  you, your money will help pay for a student’s
                  admission, hotel room (for traveling students), and
                  this year’s “hacker education kit”.
                </p>
                <div className="tab-title">
                  Would you like to hear more? Please contact{" "}
                  <a
                    href="mailto:sponsor@kernelcon.org?Subject=Sponorship"
                    style={{ textDecoration: "underline" }}
                    target="_top">
                    sponsor@kernelcon.org
                  </a>
                  .
                </div>
              </div>
            </div>
            <div className="spons-page">
              <div className="text-block">
          
                <div className="past-sponsors">
                  <span className="sponsors-label">Past Sponsors:</span>
                  <span className="sponsor-year">
                    <a href="https://2025.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2025</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2024.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2024</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2023.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2023</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2022.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2022</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2021.kernelcon.org/#sponsors" target="_blank" rel="noopener noreferrer">2021</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2020.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2020</a>
                  </span>
                  <span className="sponsor-separator">|</span>
                  <span className="sponsor-year">
                    <a href="https://2019.kernelcon.org/sponsors/" target="_blank" rel="noopener noreferrer">2019</a>
                  </span>
                </div>
              </div>

              <div className="text-block spons-groups">
                {/* Diamond Sponsors */}
                <div className='spons-block'>
                  <h2 className='diamond spons-title'>Diamond</h2>
                  <div className='gp-logo'>
                    <a href="https://www.guidepointsecurity.com/"
                      target="_blank"
                      rel='noopener noreferrer'
                      className='dark-mode-logo'>
                      <img src={GuidepointLight}
                        className='spons-img plat-spons all-bright'
                        alt="Guidepoint Security"/>
                    </a>
                    <a href="https://www.guidepointsecurity.com/"
                      target="_blank"
                      rel='noopener noreferrer'
                      className='light-mode-logo'>
                      <img src={GuidepointDark}
                        className='spons-img plat-spons'
                        alt="Guidepoint Security"/>
                    </a>
                    <div className='dark-mode-logo diamond-combined-logos'>
                      <img src={KernelConCombinedLogos4}
                        className='spons-img plat-spons diamond-combined-logos-img all-bright'
                        alt="Diamond program sponsors"/>
                    </div>
                    <div className='light-mode-logo diamond-combined-logos'>
                      <img src={KernelConCombinedLogos4}
                        className='spons-img plat-spons diamond-combined-logos-img'
                        alt="Diamond program sponsors"/>
                    </div>
                  </div>
                </div>

                {/* Gold Sponsors */}
                <div className='spons-block'>
                  <h2 className='gold spons-title'>Gold</h2>
                  <a href="https://aws.amazon.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={AWSLight}
                      className='spons-img gold-spons'
                      alt="AWS"/>
                  </a>
                  <a href="https://aws.amazon.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={AWSDark}
                      className='spons-img gold-spons'
                      alt="AWS"/>
                  </a>
                  <a href="https://www.ecstech.com/"
                    target="_blank"
                    rel='noopener noreferrer'>
                    <img src={ECS}
                      className='spons-img gold-spons'
                      alt="ECS"/>
                  </a>
                  <a href="https://www.conagrabrands.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ConAgraDark}
                      className='spons-img gold-spons'
                      alt="ConAgra Brands"/>
                  </a>
                  <a href="https://www.conagrabrands.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ConAgraLight}
                      className='spons-img gold-spons'
                      alt="ConAgra Brands"/>
                  </a>
                  <a href="https://www.mutualofomaha.com/careers/careers-at-mutual/information-technology"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={MoOLight}
                      className='spons-img gold-spons'
                      alt="Mutual of Omaha"/>
                  </a>
                  <a href="https://www.mutualofomaha.com/careers/careers-at-mutual/information-technology"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={MoODark}
                      className='spons-img gold-spons'
                      alt="Mutual of Omaha"/>
                  </a>
                  <a href="https://www.zafran.io/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ZafranRegular}
                      className='spons-img gold-spons'
                      alt="Zafran"/>
                  </a>
                  <a href="https://www.zafran.io/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ZafranWhite}
                      className='spons-img gold-spons'
                      alt="Zafran"/>
                  </a>
                  <a href="https://prompt.security/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={PromptS1Regular}
                      className='spons-img gold-spons'
                      alt="Prompt-S1"/>
                  </a>
                  <a href="https://prompt.security/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={PromptS1White}
                      className='spons-img gold-spons'
                      alt="Prompt-S1"/>
                  </a>
                  <a href="https://www.fcsamerica.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={FarmCreditLight}
                      className='spons-img gold-spons'
                      alt="Farm Credit Services of America"/>
                  </a>
                  <a href="https://www.fcsamerica.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={FarmCreditDark}
                      className='spons-img gold-spons'
                      alt="Farm Credit Services of America"/>
                  </a>
                  <a href="https://www.halcyon.ai/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={HalcyonLight}
                      className='spons-img gold-spons'
                      alt="Halcyon"/>
                  </a>
                  <a href="https://www.halcyon.ai/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={HalcyonDark}
                      className='spons-img gold-spons'
                      alt="Halcyon"/>
                  </a>
                  <a href="https://www.zscaler.com"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ZscalerLight}
                      className='spons-img gold-spons'
                      alt="Zscaler"/>
                  </a>
                  <a href="https://www.zscaler.com"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ZscalerDark}
                      className='spons-img gold-spons'
                      alt="Zscaler"/>
                  </a>
                  <a href="https://ethicalintruder.com/"
                    target="_blank"
                    rel='noopener noreferrer'>
                    <img src={EthicalIntruder}
                      className='spons-img gold-spons'
                      alt="Ethical Intruder"/>
                  </a>
                  <a href="https://www.extrahop.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={ExtraHop}
                      className='spons-img gold-spons'
                      alt="ExtraHop"/>
                  </a>
                  <a href="https://www.extrahop.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={ExtraHop}
                      className='spons-img gold-spons'
                      alt="ExtraHop"/>
                  </a>
                  <a href="https://www.rapid7.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={Rapid7Light}
                      className='spons-img gold-spons'
                      alt="Rapid7"/>
                  </a>
                  <a href="https://www.rapid7.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={Rapid7Dark}
                      className='spons-img gold-spons'
                      alt="Rapid7"/>
                  </a>
                  <a href="https://www.surf.ai/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={SurfAIDark}
                      className='spons-img gold-spons'
                      alt="Surf AI"/>
                  </a>
                  <a href="https://www.surf.ai/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={SurfAIWhite}
                      className='spons-img gold-spons'
                      alt="Surf AI"/>
                  </a>
                  <a href="https://www.crowdstrike.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={CrowdStrikeLight}
                      className='spons-img gold-spons crowdstrike-logo'
                      alt="CrowdStrike"/>
                  </a>
                  <a href="https://www.crowdstrike.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={CrowdStrikeDark}
                      className='spons-img gold-spons crowdstrike-logo'
                      alt="CrowdStrike"/>
                  </a>
                  <a href="https://www.threatlocker.com/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ThreatLockerColor}
                      className='spons-img gold-spons'
                      alt="ThreatLocker"/>
                  </a>
                  <a href="https://www.threatlocker.com/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ThreatLockerWhite}
                      className='spons-img gold-spons'
                      alt="ThreatLocker"/>
                  </a>
                </div>

                {/* Silver Sponsors */}
                <div className='spons-block'>
                  <h3 className='silver spons-title'>Silver</h3>
                  <a href="https://www.shamarinfosec.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='dark-mode-logo'>
                    <img src={Shamar}
                      className='spons-img silver-spons all-bright'
                      alt="Shamar Information Security"/>
                  </a>
                  <a href="https://www.shamarinfosec.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={Shamar}
                      className='spons-img silver-spons'
                      alt="Shamar Information Security"/>
                  </a>
                  <a href="https://www.optiv.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={OptivLogo}
                      className='spons-img silver-spons'
                      alt="Optiv"/>
                  </a>
                  <a href="https://www.optiv.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={OptivLogo}
                      className='spons-img silver-spons'
                      alt="Optiv"/>
                  </a>
                  <a href="https://www.rubrik.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={RubrikLogo}
                      className='spons-img silver-spons'
                      alt="Rubrik"/>
                  </a>
                  <a href="https://www.rubrik.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={RubrikLogo}
                      className='spons-img silver-spons'
                      alt="Rubrik"/>
                  </a>
                </div>

                {/* Bronze Sponsors */}
                <div className='spons-block'>
                  <h4 className='bronze spons-title'>Bronze</h4>
                  <a href="https://www.turngate.io/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={Turngate}
                      className='spons-img other-spons'
                      alt="Turngate"/>
                  </a>
                  <a href="https://www.turngate.io/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={Turngate}
                      className='spons-img other-spons'
                      alt="Turngate"/>
                  </a>
                  <a href="https://firecompass.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={FireCompassLight}
                      className='spons-img silver-spons ctf-spons-logo'
                      alt="FireCompass"/>
                  </a>
                  <a href="https://firecompass.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={FireCompassLight}
                      className='spons-img silver-spons ctf-spons-logo'
                      alt="FireCompass"/>
                  </a>
                </div>

                {/* CTF Sponsors */}
                <div className='spons-block'>
                  <h4 className='ctf-spons spons-title'>CTF Sponsors</h4>
                  <a href="https://firecompass.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='all-bright dark-mode-logo'>
                    <img src={FireCompassLight}
                      className='spons-img silver-spons ctf-spons-logo'
                      alt="FireCompass"/>
                  </a>
                  <a href="https://firecompass.com/"
                    target="_blank"
                    rel='noopener noreferrer'
                    className='light-mode-logo'>
                    <img src={FireCompassLight}
                      className='spons-img silver-spons ctf-spons-logo'
                      alt="FireCompass"/>
                  </a>
                </div>

                {/* Other Sponsors */}
                {/* <div className='spons-block'>
                  <h4 className='gold spons-title'>Other Sponsors</h4>
                  <a href="https://toool.us/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={ToooLDarkMode}
                      className='spons-img silver-spons'
                      alt="TOOOL"/>
                  </a>
                  <a href="https://toool.us/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={TooolLightMode}
                      className='spons-img silver-spons'
                      alt="TOOOL"/>
                  </a>
                  <a href="https://www.falkorsecurity.com/"
                    target="_blank"
                    className=''
                    rel='noopener noreferrer'>
                    <img src={Falkor}
                      className='spons-img silver-spons'
                      alt="Falkor Security"/>
                  </a>
                  <a href="https://www.mentalhealthhackers.org/"
                    target="_blank"
                    className='dark-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={MentalHealthHackersDark}
                      className='spons-img silver-spons'
                      alt="Mental Health Hackers"/>
                  </a>
                  <a href="https://www.mentalhealthhackers.org/"
                    target="_blank"
                    className='light-mode-logo'
                    rel='noopener noreferrer'>
                    <img src={MentalHealthHackersLight}
                      className='spons-img silver-spons'
                      alt="Mental Health Hackers"/>
                  </a>
                  <a href="https://www.teksystems.com/en/"
                    target="_blank"
                    rel='noopener noreferrer'>
                    <img src={TekSystems}
                      className='spons-img silver-spons'
                      alt="TEKsystems"/>
                  </a>
                  <a href="https://www.runza.com/"
                    target="_blank"
                    rel='noopener noreferrer'>
                    <img src={Runza}
                      className='spons-img silver-spons'
                      alt="Runza"/>
                  </a>
                  <br />
                </div> */}

                {/* Food & Beverage Sponsors */}
                <div className='spons-block'>
                  <div className='foodbev-spons'>
                    <div className='single-foodbev-spons'>
                      <h6 className='text-highlight spons-title'>Popcorn</h6>
                      <a href="https://www.turngate.io/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='all-bright dark-mode-logo'>
                        <img src={Turngate}
                          className='spons-img fdbev-spons'
                          alt="Turngate"/>
                      </a>
                      <a href="https://www.turngate.io/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='light-mode-logo'>
                        <img src={Turngate}
                          className='spons-img fdbev-spons'
                          alt="Turngate"/>
                      </a>
                    </div>
                  </div>
                </div>

                {/* Coffee Sponsors */}
                <div className='spons-block'>
                  <div className='foodbev-spons'>
                    <div className='single-foodbev-spons'>
                      <h6 className='text-highlight spons-title'>Coffee</h6>
                      <a href="https://cribl.io/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='dark-mode-logo'>
                        <img src={CriblDark}
                          className='spons-img fdbev-spons cribl-logo'
                          alt="Cribl"/>
                      </a>
                      <a href="https://cribl.io/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='light-mode-logo'>
                        <img src={CriblLight}
                          className='spons-img fdbev-spons cribl-logo'
                          alt="Cribl"/>
                      </a>
                      <a href="https://www.trace3.com/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='dark-mode-logo'>
                        <img src={Trace3Dark}
                          className='spons-img fdbev-spons'
                          alt="Trace3"/>
                      </a>
                      <a href="https://www.trace3.com/"
                        target="_blank"
                        rel='noopener noreferrer'
                        className='light-mode-logo'>
                        <img src={Trace3Light}
                          className='spons-img fdbev-spons'
                          alt="Trace3"/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
		);
	}
}
